import React from 'react';
import { LegalDisclaimerList } from './legal-disclaimer-list';
import { LegalDisclaimerSingleType, LegalDisclaimerSingle } from './legal-disclaimer-single';

export interface LegalDisclaimerProps {
  legalDisclaimers: LegalDisclaimerSingleType[];
}

export const LegalDisclaimer: React.FC<LegalDisclaimerProps> = ({ legalDisclaimers }) =>
  legalDisclaimers?.length === 1 ? (
    <LegalDisclaimerSingle {...legalDisclaimers[0]}></LegalDisclaimerSingle>
  ) : (
    <LegalDisclaimerList legalDisclaimers={legalDisclaimers}></LegalDisclaimerList>
  );
